import { createContext } from 'react';

const TableContext = createContext({
  optionName: false,
  reset: () => {}
});

export default TableContext;